{
    "0QziRL28RgBeD5hrmBfUr": {
        "key": "0QziRL28RgBeD5hrmBfUr",
        "position": {
            "x": 13,
            "y": 22,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "2j8ZQDAVd3IhNW_AjwPfA": {
        "key": "2j8ZQDAVd3IhNW_AjwPfA",
        "position": {
            "x": 14,
            "y": 22,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "rWszjXmWzCa71nBSVN8di": {
        "key": "rWszjXmWzCa71nBSVN8di",
        "position": {
            "x": 15,
            "y": 22,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "yvcWLLwGesAo-CI9CHg4N": {
        "key": "yvcWLLwGesAo-CI9CHg4N",
        "position": {
            "x": 13,
            "y": 18,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "WeXLbGJU8jO8CW4GhhVw0": {
        "key": "WeXLbGJU8jO8CW4GhhVw0",
        "position": {
            "x": 14,
            "y": 18,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "_bxSmy3RIeZJj9ZzX0iT2": {
        "key": "_bxSmy3RIeZJj9ZzX0iT2",
        "position": {
            "x": 15,
            "y": 18,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "vK84aULEtgXf1Ixzr-3yK": {
        "key": "vK84aULEtgXf1Ixzr-3yK",
        "position": {
            "x": 13,
            "y": 14,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "ioDRp_mgh00fbOeAaYd8K": {
        "key": "ioDRp_mgh00fbOeAaYd8K",
        "position": {
            "x": 14,
            "y": 14,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "iyJJrxX_VOKBhArWKfpwY": {
        "key": "iyJJrxX_VOKBhArWKfpwY",
        "position": {
            "x": 15,
            "y": 14,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "dLj4uhtYnrZZO4hlQdCm-": {
        "key": "dLj4uhtYnrZZO4hlQdCm-",
        "position": {
            "x": 13,
            "y": 10,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "zuE5CJ1C4ePx-4MXoLO0k": {
        "key": "zuE5CJ1C4ePx-4MXoLO0k",
        "position": {
            "x": 14,
            "y": 10,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "H9B1A8p7Y7hHcaz6HqdfZ": {
        "key": "H9B1A8p7Y7hHcaz6HqdfZ",
        "position": {
            "x": 15,
            "y": 10,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "7_mA84BK6xYkKpEUPy6RR": {
        "key": "7_mA84BK6xYkKpEUPy6RR",
        "position": {
            "x": 12,
            "y": 14,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "wYF9Ql4y33cVUTRBYtHVy": {
        "key": "wYF9Ql4y33cVUTRBYtHVy",
        "position": {
            "x": 16,
            "y": 10,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "NoUmBiLcsDopfV_nJ88HR": {
        "key": "NoUmBiLcsDopfV_nJ88HR",
        "position": {
            "x": 12,
            "y": 10,
            "z": 1
        },
        "tag": "spawnspot"
    }
}